<template>
  <div>
    <template v-if="display==1">
      <h5>商品管理<span>　<span>{{ productCount }}</span>件</span></h5>
      <label for="status" class="col-form-label">ステータス:</label>
      <select class="my-2" v-model="searchForm.type">
        <option v-for="(item, index) in status" :value="item.no" :key="`status-${item.no}`">{{ item.name }}</option>
      </select>
      <br>
      <label for="status" class="col-form-label">並び替え:</label>
      <select class="my-2 mr-3" v-model="searchForm.sort">
        <option v-for="(item, index) in sort" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
      </select>
      <a class="btn btn-info col-md-1 my-2" href="javascript:void(0);" @click="searchProduct">検索</a>
      <hr>
      <div>
        <a class="btn btn-info col-md-4" href="javascript:void(0);" @click="newProduct"> ＋ 新しい商品ページを作る</a>
      </div>
      <div class="py-3 product_contents">
        <div v-for="(product, index) in allGetProducts">
          <div class="card col-md-12 pl-0 pr-0 m-0 mb-2">
              <div class="card-header">
                  <div class="row">
                      <span class="col-md-8 text-left">{{ product['title'] }}</span>
                      <span class="col-md-4 text-right">
                        <template v-if="String(product['status'])=='0'">
                          <a href="javascript:void(0);" @click="editProductSave(product['id'])" class="btn btn-primary btn-sm">編集</a>
                        </template>
                        <template v-else-if="String(product['status'])!='3'">
                          <a href="javascript:void(0);" @click="editProduct(product['id'])" class="btn btn-primary btn-sm">編集</a>
                        </template>
                        <template v-if="String(product['status'])=='1'">
                          <a href="javascript:void(0);" @click="statusChange(product['id'], 2)" class="btn btn-secondary btn-sm">公開停止</a>
                        </template>
                      </span>
                  </div>
              </div>
              <div class="card-body">
                  <div class="row px-3">
                      <div class="col-md-3 pl-1 pr-1 m-0">
                        <img class="" :src="product['image1']" style="width: 100%;height: auto;">
                      </div>
                      <div class="card col-md-9 pl-0 pr-0 m-0">
                          <div class="card-body">
                              <p class="card-text">掲載日:　{{ date_only_format(product['opened_at']) }}</p><!-- YYYY年MM月DD日 -->
                              <p class="card-text" style="color: red;">価格(税抜):　{{ String(product['price']).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') }}円</p>
                              <p class="card-text">ブランド:　{{ get_hash_value(brand, product['brand']) }}</p>
                              <p class="card-text">型番:　{{ product['model_number'] }}</p>
                              <p class="card-text">
                                ♡ {{ product['favoriteCount'] }} 💬 {{ product['commentCount'] }} 👁 {{ product['viewCount'] }} ⏱ {{ product['openTime'] }}日前
                              </p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </div>
        <div class="page" v-show="productCount>0">
          <vuejs-paginate
            :page-count="allGetPageCount"
            :page-range="3"
            :margin-pages="2"
            :click-handler="allClickCallback"
            :prev-text="'＜'"
            :next-text="'＞'"
            :container-class="'pagination'"
            :page-class="'page-item'">
          </vuejs-paginate>
        </div>
      </div>
    </template>

    <template v-if="display==2">
      <h5>商品を作る</h5>
      <a class="btn btn-info col-md-4" href="javascript:void(0);" @click="backProduct">戻る</a>
      <hr>
      <div class="form-group">
          <div class="col-sm-12 px-1">
              <label class="col-sm-12 control-label">商品のタイトル  <span class="required_mark">必須</span></label>
              <textarea placeholder="記入例：国産 YAMAHA （ヤマハ） YS6　お子様の初めてのピアノとして最適！　弾きやすさ抜群！" v-model="productForm.title" class="required form-control" rows="2" v-bind:class="{ error_input: productForm.errors.title.length > 0 }"></textarea>
              <div v-if="productForm.errors.title.length > 0">
                <div class="error-text" v-for="(item, index) in productForm.errors.title" :key="index">{{ item }}</div>
              </div>
          </div>
      </div>
      <div class="form-group">
          <div class="col-sm-12 px-1">
              <label class="col-sm-12 control-label">アピールポイント  <span class="required_mark">必須</span></label>
              <textarea placeholder="" v-model="productForm.strong_point" class="required form-control" rows="5" maxlength="150" v-bind:class="{ error_input: productForm.errors.strong_point.length > 0 }"></textarea>
              <div v-if="productForm.errors.strong_point.length > 0">
                <div class="error-text" v-for="(item, index) in productForm.errors.strong_point" :key="index">{{ item }}</div>
              </div>
          </div>
      </div>
      <div class="form-group">
        <div class="col-sm-12 px-1">
            <label for="" class="col-sm-12 control-label">商品画像 推奨サイズ(600px X 800px)<span class="required_mark">1枚必須</span></label>
            <div class="row mt-2 mb-2 mx-0">
                <div class="col-sm-3">
                    <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2" v-bind:class="{ error_input: productForm.errors.image.length > 0 }">
                      <img :src="productForm.image1" class="my-3">
                    </div>
                    <label class="col-sm-12 btn btn-warning" @click="uploadImage1">選択</label>
                    <input type="file" style="display: none" ref="input1" @change="onImageChange1"/>
                </div>
                <div class="col-sm-3">
                    <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2">
                      <img :src="productForm.image2" class="my-3">
                    </div>
                    <label class="col-sm-12 btn btn-warning" @click="uploadImage2">選択</label>
                    <input type="file" style="display: none" ref="input2" @change="onImageChange2"/>
                </div>
                <div class="col-sm-3">
                    <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2">
                      <img :src="productForm.image3" class="my-3">
                    </div>
                    <label class="col-sm-12 btn btn-warning" @click="uploadImage3">選択</label>
                    <input type="file" style="display: none" ref="input3" @change="onImageChange3"/>
                </div>
                <div class="col-sm-3">
                    <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2">
                      <img :src="productForm.image4" class="my-3">
                    </div>
                    <label class="col-sm-12 btn btn-warning" @click="uploadImage4">選択</label>
                    <input type="file" style="display: none" ref="input4" @change="onImageChange4"/>
                </div>
            </div>
            <div class="row mt-2 mb-2 mx-0">
                <div class="col-sm-3">
                    <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2">
                      <img :src="productForm.image5" class="my-3">
                    </div>
                    <label class="col-sm-12 btn btn-warning" @click="uploadImage5">選択</label>
                    <input type="file" style="display: none" ref="input5" @change="onImageChange5"/>
                </div>
                <div class="col-sm-3">
                    <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2">
                      <img :src="productForm.image6" class="my-3">
                    </div>
                    <label class="col-sm-12 btn btn-warning" @click="uploadImage6">選択</label>
                    <input type="file" style="display: none" ref="input6" @change="onImageChange6"/>
                </div>
                <div class="col-sm-3">
                    <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2">
                      <img :src="productForm.image7" class="my-3">
                    </div>
                    <label class="col-sm-12 btn btn-warning" @click="uploadImage7">選択</label>
                    <input type="file" style="display: none" ref="input7" @change="onImageChange7"/>
                </div>
                <div class="col-sm-3">
                    <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2">
                      <img :src="productForm.image8" class="my-3">
                    </div>
                    <label class="col-sm-12 btn btn-warning" @click="uploadImage8">選択</label>
                    <input type="file" style="display: none" ref="input8" @change="onImageChange8"/>
                </div>
            </div>
            <div class="row mt-2 mb-2 mx-0">
                <div class="col-sm-3">
                    <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2">
                      <img :src="productForm.image9" class="my-3">
                    </div>
                    <label class="col-sm-12 btn btn-warning" @click="uploadImage9">選択</label>
                    <input type="file" style="display: none" ref="input9" @change="onImageChange9"/>
                </div>
                <div class="col-sm-3">
                    <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2">
                      <img :src="productForm.image10" class="my-3">
                    </div>
                    <label class="col-sm-12 btn btn-warning" @click="uploadImage10">選択</label>
                    <input type="file" style="display: none" ref="input10" @change="onImageChange10"/>
                </div>
                <div class="col-sm-3">
                    <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2">
                      <img :src="productForm.image11" class="my-3">
                    </div>
                    <label class="col-sm-12 btn btn-warning" @click="uploadImage11">選択</label>
                    <input type="file" style="display: none" ref="input11" @change="onImageChange11"/>
                </div>
                <div class="col-sm-3">
                    <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2">
                      <img :src="productForm.image12" class="my-3">
                    </div>
                    <label class="col-sm-12 btn btn-warning" @click="uploadImage12">選択</label>
                    <input type="file" style="display: none" ref="input12" @change="onImageChange12"/>
                </div>
            </div>
            <div class="row mt-2 mb-2 mx-0">
                <div class="col-sm-4">
                    <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2">
                      <img :src="productForm.image13" class="my-3">
                    </div>
                    <label class="col-sm-12 btn btn-warning" @click="uploadImage13">選択</label>
                    <input type="file" style="display: none" ref="input13" @change="onImageChange13"/>
                </div>
                <div class="col-sm-4">
                    <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2">
                      <img :src="productForm.image14" class="my-3">
                    </div>
                    <label class="col-sm-12 btn btn-warning" @click="uploadImage14">選択</label>
                    <input type="file" style="display: none" ref="input14" @change="onImageChange14"/>
                </div>
                <div class="col-sm-4">
                    <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2">
                      <img :src="productForm.image15" class="my-3">
                    </div>
                    <label class="col-sm-12 btn btn-warning" @click="uploadImage15">選択</label>
                    <input type="file" style="display: none" ref="input15" @change="onImageChange15"/>
                </div>
            </div>
            <div v-if="productForm.errors.image.length > 0">
              <div class="error-text" v-for="(item, index) in productForm.errors.image" :key="index">{{ item }}</div>
            </div>
        </div>
      </div>
      <div class="form-group">
          <div class="col-sm-12 px-1">
              <label class="col-sm-12 control-label">動画での商品紹介・演奏の表示用の埋め込みタグ<br><span>youtubeの共有埋め込みタグをコピーしたものを、以下に埋め込んでください。<span style="color: red;">（※ただし、動画の内容に自社のホームページ等のURLを表示するなど、動画内での宣伝行為は禁止とします。宣伝行為が確認できた場合は、埋め込みタグの削除となりますのでご了解ください。）</span></span></label>
              <textarea placeholder="" v-model="productForm.movie_tag" class="required form-control" rows="2" v-bind:class="{ error_input: productForm.errors.movie_tag.length > 0 }"></textarea>
              <div v-if="productForm.errors.movie_tag.length > 0">
                <div class="error-text" v-for="(item, index) in productForm.errors.movie_tag" :key="index">{{ item }}</div>
              </div>
          </div>
      </div>
      <div class="form-group">
          <div class="col-sm-12 px-1">
              <label class="col-sm-12 control-label">動画の紹介者、演奏者のコメント</label>
              <textarea placeholder="" v-model="productForm.comment" class="required form-control" rows="5" v-bind:class="{ error_input: productForm.errors.comment.length > 0 }"></textarea>
              <div v-if="productForm.errors.comment.length > 0">
                <div class="error-text" v-for="(item, index) in productForm.errors.comment" :key="index">{{ item }}</div>
              </div>
          </div>
      </div>
      <div class="form-group">
          <div class="col-sm-12 px-1">
              <label class="col-sm-12 control-label">価格（税抜） <span class="required_mark">必須</span></label>
              <input style="width: 200px;display: inline-block;" type="tel" v-model="productForm.price" class="required form-control" v-bind:class="{ error_input: productForm.errors.price.length > 0 }">　円
              <div v-if="productForm.errors.price.length > 0">
                <div class="error-text" v-for="(item, index) in productForm.errors.price" :key="index">{{ item }}</div>
              </div>
          </div>
      </div>
      <div class="form-group">
          <h5 class="my-4">商品スペック</h5>
          <div class="form-group">
            <div class="col-sm-12 px-1">
                <label class="col-sm-12 control-label">状態 <span class="required_mark">必須</span></label>
                <select v-bind:class="{ error_input: productForm.errors.state.length > 0 }" v-model="productForm.state">
                  <option v-for="(item, index) in state" :value="index+1" :key="`state-${item.no}`">{{ item.name }}</option>
                </select>
                <div v-if="productForm.errors.state.length > 0">
                  <div class="error-text" v-for="(item, index) in productForm.errors.state" :key="index">{{ item }}</div>
                </div>
            </div>
          </div>
          <div class="form-group">
            <div class="col-sm-12 px-1">
                <label class="col-sm-12 control-label">タイプ <span class="required_mark">必須</span></label>
                <select v-bind:class="{ error_input: productForm.errors.type.length > 0 }" v-model="productForm.type">
                  <option v-for="(item, index) in type" :value="index+1" :key="`type-${item.no}`">{{ item.name }}</option>
                </select>
                <div v-if="productForm.errors.type.length > 0">
                  <div class="error-text" v-for="(item, index) in productForm.errors.type" :key="index">{{ item }}</div>
                </div>
            </div>
          </div>
          <div class="form-group">
            <div class="col-sm-12 px-1">
                <label class="col-sm-12 control-label">ブランド <span class="required_mark">必須</span></label>
                <select v-bind:class="{ error_input: productForm.errors.brand.length > 0 }" v-model="productForm.brand">
                  <option v-for="(item, index) in brand" :value="index+1" :key="`brand-${item.no}`">{{ item.name }}</option>
                </select>
                <div v-if="productForm.errors.brand.length > 0">
                  <div class="error-text" v-for="(item, index) in productForm.errors.brand" :key="index">{{ item }}</div>
                </div>
            </div>
          </div>
          <div class="form-group">
            <div class="col-sm-12 px-1">
                <label class="col-sm-12 control-label">型番</label>
                <textarea placeholder="" v-model="productForm.model_number" class="form-control" rows="1" v-bind:class="{ error_input: productForm.errors.model_number.length > 0 }"></textarea>
                <div v-if="productForm.errors.model_number.length > 0">
                  <div class="error-text" v-for="(item, index) in productForm.errors.model_number" :key="index">{{ item }}</div>
                </div>
            </div>
          </div>
          <div class="form-group">
            <div class="col-sm-12 px-1">
                <label class="col-sm-12 control-label">サイズ <span class="required_mark">必須</span></label>
                <div class="row mt-2 mb-2 mx-0">
                    <div class="col-sm-4">
                      <label class="col-sm-12 control-label">高さ</label>
                      <textarea style="width: 65%;display: inline-block;" placeholder="" v-model="productForm.size_height" class="form-control" rows="1" v-bind:class="{ error_input: productForm.errors.size_height.length > 0 }"></textarea>　CM
                      <div v-if="productForm.errors.size_height.length > 0">
                        <div class="error-text" v-for="(item, index) in productForm.errors.size_height" :key="index">{{ item }}</div>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <label class="col-sm-12 control-label">幅</label>
                      <textarea style="width: 65%;display: inline-block;" placeholder="" v-model="productForm.size_width" class="form-control" rows="1" v-bind:class="{ error_input: productForm.errors.size_width.length > 0 }"></textarea>　CM
                      <div v-if="productForm.errors.size_width.length > 0">
                        <div class="error-text" v-for="(item, index) in productForm.errors.size_width" :key="index">{{ item }}</div>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <label class="col-sm-12 control-label">奥行</label>
                      <textarea style="width: 65%;display: inline-block;" placeholder="" v-model="productForm.size_depth" class="form-control" rows="1" v-bind:class="{ error_input: productForm.errors.size_depth.length > 0 }"></textarea>　CM
                      <div v-if="productForm.errors.size_depth.length > 0">
                        <div class="error-text" v-for="(item, index) in productForm.errors.size_depth" :key="index">{{ item }}</div>
                      </div>
                    </div>
                </div>
            </div>
          </div>
          <div class="form-group">
              <div class="col-sm-12 px-1">
                  <label class="col-sm-12 control-label">重量</label>
                  <input style="width: 200px;display: inline-block;" type="tel" v-model="productForm.weight" class="required form-control" v-bind:class="{ error_input: productForm.errors.weight.length > 0 }">　Kg
                  <div v-if="productForm.errors.weight.length > 0">
                    <div class="error-text" v-for="(item, index) in productForm.errors.weight" :key="index">{{ item }}</div>
                  </div>
              </div>
          </div>
          <div class="form-group">
            <div class="col-sm-12 px-1">
                <label class="col-sm-12 control-label">カラー <span class="required_mark">必須</span></label>
                <select v-bind:class="{ error_input: productForm.errors.color.length > 0 }" v-model="productForm.color">
                  <option v-for="(item, index) in color" :value="index+1" :key="`color-${item.no}`">{{ item.name }}</option>
                </select>
                <div v-if="productForm.errors.color.length > 0">
                  <div class="error-text" v-for="(item, index) in productForm.errors.color" :key="index">{{ item }}</div>
                </div>
            </div>
          </div>
          <div class="form-group">
            <div class="col-sm-12 px-1">
                <label class="col-sm-12 control-label">外装仕上げ</label>
                <textarea placeholder="" v-model="productForm.exterior_finish" class="form-control" rows="1" v-bind:class="{ error_input: productForm.errors.exterior_finish.length > 0 }"></textarea>
                <div v-if="productForm.errors.exterior_finish.length > 0">
                  <div class="error-text" v-for="(item, index) in productForm.errors.exterior_finish" :key="index">{{ item }}</div>
                </div>
            </div>
          </div>
          <div class="form-group">
            <div class="col-sm-12 px-1">
                <label class="col-sm-12 control-label">製造年</label>
                <select v-bind:class="{ error_input: productForm.errors.make_year.length > 0 }" v-model="productForm.make_year">
                  <option v-for="(item, index) in make_year" :value="item.no" :key="`make_year-${item.no}`">{{ item.name }}</option>
                </select>
                <div v-if="productForm.errors.make_year.length > 0">
                  <div class="error-text" v-for="(item, index) in productForm.errors.make_year" :key="index">{{ item }}</div>
                </div>
            </div>
          </div>
          <div class="form-group">
            <div class="col-sm-12 px-1">
                <label class="col-sm-12 control-label">製造番号</label>
                <textarea placeholder="" v-model="productForm.make_number" class="form-control" rows="1" v-bind:class="{ error_input: productForm.errors.make_number.length > 0 }"></textarea>
                <div v-if="productForm.errors.make_number.length > 0">
                  <div class="error-text" v-for="(item, index) in productForm.errors.make_number" :key="index">{{ item }}</div>
                </div>
            </div>
          </div>
          <div class="form-group">
            <div class="col-sm-12 px-1">
                <label class="col-sm-12 control-label">ペダル</label>
                <textarea placeholder="" v-model="productForm.pedal" class="form-control" rows="1" v-bind:class="{ error_input: productForm.errors.pedal.length > 0 }"></textarea>
                <div v-if="productForm.errors.pedal.length > 0">
                  <div class="error-text" v-for="(item, index) in productForm.errors.pedal" :key="index">{{ item }}</div>
                </div>
            </div>
          </div>
          <div class="form-group">
            <div class="col-sm-12 px-1">
                <label class="col-sm-12 control-label">鍵盤数</label>
                <textarea placeholder="" v-model="productForm.keys_number" class="form-control" rows="1" v-bind:class="{ error_input: productForm.errors.keys_number.length > 0 }"></textarea>
                <div v-if="productForm.errors.keys_number.length > 0">
                  <div class="error-text" v-for="(item, index) in productForm.errors.keys_number" :key="index">{{ item }}</div>
                </div>
            </div>
          </div>
          <div class="form-group">
            <div class="col-sm-12 px-1">
                <label class="col-sm-12 control-label">製造場所</label>
                <textarea placeholder="" v-model="productForm.make_place" class="form-control" rows="1" v-bind:class="{ error_input: productForm.errors.make_place.length > 0 }"></textarea>
                <div v-if="productForm.errors.make_place.length > 0">
                  <div class="error-text" v-for="(item, index) in productForm.errors.make_place" :key="index">{{ item }}</div>
                </div>
            </div>
          </div>
          <div class="form-group">
            <div class="col-sm-12 px-1">
                <label class="col-sm-12 control-label">保証期間</label>
                <textarea placeholder="" v-model="productForm.warranty_period" class="form-control" rows="1" v-bind:class="{ error_input: productForm.errors.warranty_period.length > 0 }"></textarea>
                <div v-if="productForm.errors.warranty_period.length > 0">
                  <div class="error-text" v-for="(item, index) in productForm.errors.warranty_period" :key="index">{{ item }}</div>
                </div>
            </div>
          </div>
          <div class="form-group">
            <div class="col-sm-12 px-1">
                <label class="col-sm-12 control-label">保管（展示）場所</label>
                <textarea placeholder="市区町村まで" v-model="productForm.storage_location" class="form-control" rows="1" v-bind:class="{ error_input: productForm.errors.storage_location.length > 0 }"></textarea>
                <div v-if="productForm.errors.storage_location.length > 0">
                  <div class="error-text" v-for="(item, index) in productForm.errors.storage_location" :key="index">{{ item }}</div>
                </div>
            </div>
          </div>
      </div>
      <div class="form-group">
          <div class="col-sm-12 px-1">
              <label class="col-sm-12 control-label">このピアノの特徴  <span class="required_mark">必須</span></label>
              <textarea placeholder="記入例：小スペースのお部屋にマッチする、高さ115cmのコンパクトサイズのピアノです。カワイ特有のまろやかで疲れない音色ですが、音量が大きすぎないのが特徴です。設置スペースで悩まれている方、マンションなどで音を気にされている方、またピアノレッスンに通い始めたお子様の入門用として、ぜひ検討いただいたい1台です。" v-model="productForm.piano_feature" class="required form-control" rows="5"  v-bind:class="{ error_input: productForm.errors.piano_feature.length > 0 }"></textarea>
              <div v-if="productForm.errors.piano_feature.length > 0">
                <div class="error-text" v-for="(item, index) in productForm.errors.piano_feature" :key="index">{{ item }}</div>
              </div>
          </div>
      </div>
      <div class="form-group">
          <div class="col-sm-12 px-1">
              <label class="col-sm-12 control-label">このピアノの状態  <span class="required_mark">必須</span></label>
              <textarea placeholder="記入例：中古ピアノですが、大きな傷もなくお買い得です。鍵盤の状態も良く、とてもひきやすいです。ハンマーもきれいに成形されており、美しい音色を聞かせてくれます。ダンパーペダルに錆びはありますが、音の伸びは良く機能的に問題ありません。" v-model="productForm.piano_status" class="required form-control" rows="5"  v-bind:class="{ error_input: productForm.errors.piano_status.length > 0 }"></textarea>
              <div v-if="productForm.errors.piano_status.length > 0">
                <div class="error-text" v-for="(item, index) in productForm.errors.piano_status" :key="index">{{ item }}</div>
              </div>
          </div>
      </div>
      <div class="form-group">
          <div class="col-sm-12 px-1">
              <label class="col-sm-12 control-label">整備担当者の名前</label>
              <textarea placeholder="" v-model="productForm.manager_name" class="form-control" rows="1" v-bind:class="{ error_input: productForm.errors.manager_name.length > 0 }"></textarea>
              <div v-if="productForm.errors.manager_name.length > 0">
                <div class="error-text" v-for="(item, index) in productForm.errors.manager_name" :key="index">{{ item }}</div>
              </div>
          </div>
      </div>
      <div class="form-group">
          <div class="col-sm-12 px-1">
              <label class="col-sm-12 control-label">このピアノの整備でこだわったポイント</label>
              <textarea placeholder="" v-model="productForm.manager_point" class="required form-control" rows="5" maxlength="150" v-bind:class="{ error_input: productForm.errors.manager_point.length > 0 }"></textarea>
              <div v-if="productForm.errors.manager_point.length > 0">
                <div class="error-text" v-for="(item, index) in productForm.errors.manager_point" :key="index">{{ item }}</div>
              </div>
          </div>
      </div>
      <div class="form-group">
        <div class="col-sm-4 px-1">
            <label for="" class="col-sm-12 control-label">整備担当者の画像 推奨サイズ(600px X 800px)</label>
            <div style="border: solid 1px #bab7b7;border-radius: 4px;min-height: 100px;width: auto;" class="mb-2" v-bind:class="{ error_input: productForm.errors.manager_image.length > 0 }">
              <img :src="productForm.manager_image" class="my-3">
            </div>
            <label class="col-sm-12 btn btn-warning" @click="uploadImage99">選択</label>
            <input type="file" style="display: none" ref="input99" @change="onImageChange99"/>
        </div>
      </div>
      <div class="form-group">
          <div class="col-sm-12 px-1">
              <label class="col-sm-12 control-label">付属品</label>
              <textarea placeholder="" v-model="productForm.accessories" class="form-control" rows="1" v-bind:class="{ error_input: productForm.errors.accessories.length > 0 }"></textarea>
              <div v-if="productForm.errors.accessories.length > 0">
                <div class="error-text" v-for="(item, index) in productForm.errors.accessories" :key="index">{{ item }}</div>
              </div>
          </div>
      </div>
      <div class="form-group">
          <div class="b100 col-sm-12">
            <template v-if="mode==1 || mode==3">
              <button type="button" class="bs100 btn btn-primary" @click="product_form_submit(1)">公開する</button>
              <button type="button" class="mt-3 bs100 btn btn-primary" @click="product_form_submit(0)">一時保存</button>
              <!-- <input class="bs100 btn btn-primary" type="submit" value="次へ"> -->
            </template>
            <template v-if="mode==2">
              <button type="button" class="bs100 btn btn-primary" @click="product_form_submit(2)">更新する</button>
            </template>
          </div>
      </div>
    </template>

  </div>
</template>

<script>
import VueJsPaginate from "vuejs-paginate";

export default {
  components: {
    'vuejs-paginate': VueJsPaginate,
  },
  props: { 
    user: Object
  },
  data() {
		const status = [
      {"no":"0","name":"下書き"},
      {"no":"1","name":"出品中"},
      {"no":"2","name":"公開停止中"},
      {"no":"3","name":"売却済み"},
    ];
		const sort = [
      {"no":"1","name":"登録日の古い順"},
      {"no":"2","name":"登録日の新しい順"},
      {"no":"3","name":"価格の低い順"},
      {"no":"4","name":"価格の高い順"},
      {"no":"5","name":"お気に入りの多い順"},
      {"no":"6","name":"コメントの多い順"},
      {"no":"7","name":"表示の多い順"},
    ];
		const state = [
      {"no":"1","name":"新古品"},
      {"no":"2","name":"中古品（非常に良い）"},
      {"no":"3","name":"中古品（良い）"},
      {"no":"4","name":"中古品（あまり良くない）"},
      {"no":"5","name":"中古品（悪い）"},
    ];
		const type = [
      {"no":"1","name":"グランドピアノ（GP）"},
      {"no":"2","name":"アップライトピアノ（UP）"},
    ];
		const brand = [
      {"no":"1","name":"ヤマハ（YAMAHA）"},
      {"no":"2","name":"カワイ（KAWAI）"},
      {"no":"3","name":"スタインウェイ・アンド・サンズ　（Steinway&Sons）"},
      {"no":"4","name":"ベーゼンドルファー　（Bösendorfer）"},
      {"no":"5","name":"ベヒシュタイン　（BECHSTEIN）"},
      {"no":"6","name":"ボストン　（BOSTON）"},
      {"no":"7","name":"ディアパソン　（DIAPASON）"},
      {"no":"8","name":"アポロ　（APOLLO）"},
      {"no":"9","name":"国産ピアノ"},
      {"no":"10","name":"輸入ピアノ"},
    ];
		const color = [
      {"no":"1","name":"黒"},
      {"no":"2","name":"木目"},
      {"no":"3","name":"白"},
      {"no":"4","name":"その他"},
    ];
    return {
      display: 1,
      status,
      sort,
      state,
      type,
      brand,
      color,
      make_year: [],
      productCount: 0,
      imageSet: false,
			all_products: [],
			all_parPage: 5,
			all_currentPage: 1,
      btn_type: null, // ボタン毎のアラートに利用
      mode: null, // 1:登録 2:更新
      searchForm: {
        type: 0,
        sort: 1,
      },
      isError: false,
      productForm: {
        errors: {
          title: [],
          strong_point: [],
          image: [],
          price: [],
          size_height: [],
          size_width: [],
          size_depth: [],
          piano_feature: [],
          piano_status: [],
          // 未使用
          movie_tag: [],
          comment: [],
          state: [],
          type: [],
          brand: [],
          model_number: [],
          weight: [],
          color: [],
          exterior_finish: [],
          make_year: [],
          make_number: [],
          pedal: [],
          keys_number: [],
          make_place: [],
          warranty_period: [],
          storage_location: [],
          manager_name: [],
          manager_image: [],
          manager_point: [],
          accessories: [],
        },
        status: 0,
        title: null,
        strong_point: null,
        image1: null,
        image2: null,
        image3: null,
        image4: null,
        image5: null,
        image6: null,
        image7: null,
        image8: null,
        image9: null,
        image10: null,
        image11: null,
        image12: null,
        image13: null,
        image14: null,
        image15: null,
        movie_tag: null,
        comment: null,
        price: null,
        state: 1,
        type: 1,
        brand: 1,
        model_number: null,
        size_height: null,
        size_width: null,
        size_depth: null,
        weight: null,
        color: 1,
        exterior_finish: null,
        make_year: 0,
        make_number: null,
        pedal: null,
        keys_number: null,
        make_place: null,
        warranty_period: null,
        storage_location: null,
        piano_feature: null,
        piano_status: null,
        manager_name: null,
        manager_image: null,
        manager_point: null,
        accessories: null,
        id: null,
      },
    }
  },
  methods: {
    searchProduct() {
      this.get_products();
      return false;
    },
    newProduct() {
      this.display = 2;
      this.mode = 1;
      this.imageSet = false;
      return false;
    },
    backProduct() {
      this.display = 1;
      this.productFormReset();
      this.get_products();
      return false;
    },
    editProduct(id) {
      this.get_product(id);
      this.display = 2;
      this.mode = 2;
      this.imageSet = true;
      return false;
    },
    editProductSave(id) { // 一時保存
      this.get_product(id);
      this.display = 2;
      this.mode = 3;
      this.imageSet = true;
      return false;
    },
    statusChange(id, status) {
      if(confirm("公開停止にしてもよろしいですか?")) {
        this.productForm.id = id;
        this.productForm.status = status;
        this.exec_update_product_status();
      }
      return false;
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    onImageChange1(e) { this.onImageChange(1, e); },
    onImageChange2(e) { this.onImageChange(2, e); },
    onImageChange3(e) { this.onImageChange(3, e); },
    onImageChange4(e) { this.onImageChange(4, e); },
    onImageChange5(e) { this.onImageChange(5, e); },
    onImageChange6(e) { this.onImageChange(6, e); },
    onImageChange7(e) { this.onImageChange(7, e); },
    onImageChange8(e) { this.onImageChange(8, e); },
    onImageChange9(e) { this.onImageChange(9, e); },
    onImageChange10(e) { this.onImageChange(10, e); },
    onImageChange11(e) { this.onImageChange(11, e); },
    onImageChange12(e) { this.onImageChange(12, e); },
    onImageChange13(e) { this.onImageChange(13, e); },
    onImageChange14(e) { this.onImageChange(14, e); },
    onImageChange15(e) { this.onImageChange(15, e); },
    onImageChange99(e) { this.onImageChange(99, e); },
    onImageChange(target, e) {
      const images = e.target.files || e.dataTransfer.files
      this.getBase64(images[0]).then(image => {
        const originalImg = new Image()
        originalImg.src = image
        originalImg.onload = () => {
          const resizedCanvas = this.createResizedCanvasElement(originalImg)
          const resizedBase64 = resizedCanvas.toDataURL(images[0].type)
          if ( target == 1 ) { this.productForm.image1 = resizedBase64 }
          if ( target == 2 ) { this.productForm.image2 = resizedBase64 }
          if ( target == 3 ) { this.productForm.image3 = resizedBase64 }
          if ( target == 4 ) { this.productForm.image4 = resizedBase64 }
          if ( target == 5 ) { this.productForm.image5 = resizedBase64 }
          if ( target == 6 ) { this.productForm.image6 = resizedBase64 }
          if ( target == 7 ) { this.productForm.image7 = resizedBase64 }
          if ( target == 8 ) { this.productForm.image8 = resizedBase64 }
          if ( target == 9 ) { this.productForm.image9 = resizedBase64 }
          if ( target == 10 ) { this.productForm.image10 = resizedBase64 }
          if ( target == 11 ) { this.productForm.image11 = resizedBase64 }
          if ( target == 12 ) { this.productForm.image12 = resizedBase64 }
          if ( target == 13 ) { this.productForm.image13 = resizedBase64 }
          if ( target == 14 ) { this.productForm.image14 = resizedBase64 }
          if ( target == 15 ) { this.productForm.image15 = resizedBase64 }
          if ( target == 99 ) { this.productForm.manager_image = resizedBase64 }
          this.imageSet = true;
        }
      }).catch(error =>
        alert('画像処理に失敗しました。再度画像を選択してください。')
      )
    },
    uploadImage1() { this.$refs.input1.click(); },
    uploadImage2() { this.$refs.input2.click(); },
    uploadImage3() { this.$refs.input3.click(); },
    uploadImage4() { this.$refs.input4.click(); },
    uploadImage5() { this.$refs.input5.click(); },
    uploadImage6() { this.$refs.input6.click(); },
    uploadImage7() { this.$refs.input7.click(); },
    uploadImage8() { this.$refs.input8.click(); },
    uploadImage9() { this.$refs.input9.click(); },
    uploadImage10() { this.$refs.input10.click(); },
    uploadImage11() { this.$refs.input11.click(); },
    uploadImage12() { this.$refs.input12.click(); },
    uploadImage13() { this.$refs.input13.click(); },
    uploadImage14() { this.$refs.input14.click(); },
    uploadImage15() { this.$refs.input15.click(); },
    uploadImage99() { this.$refs.input99.click(); },
    createResizedCanvasElement(originalImg) {
      const originalImgWidth = originalImg.width
      const orifinalImgHeight = originalImg.height
      const [resizedWidth, resizedHeight] = this.resizeWidthAndHeight(originalImgWidth, orifinalImgHeight)
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      canvas.width = resizedWidth
      canvas.height = resizedHeight
      ctx.drawImage(originalImg, 0, 0, resizedWidth, resizedHeight)
      return canvas
    },
    resizeWidthAndHeight(width, height) {
      const MAX_WIDTH = 800
      const MAX_HEIGHT = 600
      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width
          width = MAX_WIDTH
        }
      } else {
        if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height
          height = MAX_HEIGHT
        }
      }
      return [width, height]
    },    
    product_form_submit(btn_type) {
      this.btn_type = btn_type;
      // 0:下書き 1:出品中 2:公開停止 3:売却済み
      if ( btn_type == 0 ) {
        this.productForm.status = 0;
      } else if ( btn_type == 1 || btn_type == 2 ) {
        this.productForm.status = 1;
      }
			this.isError = false;
			this.productForm.errors.title = [];
			this.productForm.errors.image = [];
			this.productForm.errors.strong_point = [];
			this.productForm.errors.price = [];
			// this.productForm.errors.state = [];
			// this.productForm.errors.type = [];
			// this.productForm.errors.brand = [];
			this.productForm.errors.model_number = [];
			this.productForm.errors.size_height = [];
			this.productForm.errors.size_width = [];
			this.productForm.errors.size_depth = [];
			// this.productForm.errors.color = [];
			this.productForm.errors.piano_feature = [];
			this.productForm.errors.piano_status = [];
      if (!this.imageSet) {
        this.productForm.errors.image.push('画像は最低１つ選択してください');
        this.isError = true;
      }
			if (!this.productForm.title) {
				this.productForm.errors.title.push('商品のタイトルが入力されていません');
				this.isError = true;
			}
			if (!this.productForm.strong_point) {
				this.productForm.errors.strong_point.push('アピールポイントが入力されていません');
				this.isError = true;
			}
			if (!this.productForm.price) {
				this.productForm.errors.price.push('価格（税抜）が入力されていません');
				this.isError = true;
      } else {
        let check_num = String(this.productForm.price).replace(/[^0-9]/g, '');
        if (check_num == '') {
          this.productForm.errors.price.push('価格（税抜）が正しく入力されていません');
          this.isError = true;
        }
      }
			if (this.productForm.model_number) {
        let reg = new RegExp(/^[0-9A-Z]*$/);
        if ( !reg.test(this.productForm.model_number) ) {
          this.productForm.errors.model_number.push('型番は大文字の半角英数字で入力してください（例：CR20）');
          this.isError = true;
        }        
			}
			if (!this.productForm.size_height) {
				this.productForm.errors.size_height.push('サイズ（高さ）が入力されていません');
				this.isError = true;
			}
			if (!this.productForm.size_width) {
				this.productForm.errors.size_width.push('サイズ（幅）が入力されていません');
				this.isError = true;
			}
			if (!this.productForm.size_depth) {
				this.productForm.errors.size_depth.push('サイズ（奥行）が入力されていません');
				this.isError = true;
			}
			if (!this.productForm.piano_feature) {
				this.productForm.errors.piano_feature.push('このピアノの特徴が入力されていません');
				this.isError = true;
			}
			if (!this.productForm.piano_status) {
				this.productForm.errors.piano_status.push('このピアノの状態が入力されていません');
				this.isError = true;
			}
			if (!this.isError) {
        if ( this.mode == 1 ) {
  				this.exec_new_product();
        } else if ( this.mode == 2 || this.mode == 3 ) {
  				this.exec_update_product();
        }
			} else {
				window.scrollTo({
					top: 0,
				});
			}
      return false;
    },
    // 商品登録処理
    async exec_new_product() {
      this.$store.dispatch('product/new_product', {
        product: this.productForm,
      }).then(res => {
        console.log(res);
        if ( this.btn_type == 0 ) {
          alert('一時保存が完了しました。');
        } else if ( this.btn_type == 1 ) {
          alert('商品登録・公開が完了しました。');
        } else if ( this.btn_type == 2 ) {
          alert('更新が完了しました。');
        }
        window.scrollTo({
          top: 0,
        });
        // this.$router.push({path: '/mypage'});
        this.productFormReset();
        this.backProduct();
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error.response.data);
        if ('error' in error.response.data) {
          alert(error.response.data['error']);
          window.scrollTo({
            top: 0,
          });
        }
      });
      return false;
    },
    // 商品更新処理
    async exec_update_product() {
      this.$store.dispatch('product/upd_product', {
        product: this.productForm,
      }).then(res => {
        console.log(res);
        if ( this.btn_type == 0 ) {
          alert('一時保存が完了しました。');
        } else if ( this.btn_type == 1 ) {
          alert('商品登録・公開が完了しました。');
        } else if ( this.btn_type == 2 ) {
          alert('更新が完了しました。');
        }
        window.scrollTo({
          top: 0,
        });
        // this.$router.push({path: '/mypage'});
        this.productFormReset();
        this.backProduct();
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error.response.data);
        if ('error' in error.response.data) {
          alert(error.response.data['error']);
          window.scrollTo({
            top: 0,
          });
        }
      });
      return false;
    },
    // 商品ステータス更新処理
    async exec_update_product_status() {
      this.$store.dispatch('product/upd_product_status', {
        product: this.productForm,
      }).then(res => {
        console.log(res);
        alert('ステータス更新が完了しました。')
        window.scrollTo({
          top: 0,
        });
        // this.$router.push({path: '/mypage'});
        this.productFormReset();
        this.get_products();
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error.response.data);
        if ('error' in error.response.data) {
          alert(error.response.data['error']);
          window.scrollTo({
            top: 0,
          });
        }
      });
      return false;
    },
		async get_products() {
			this.$store.dispatch('product/get_products', {
        type: this.searchForm.type,
        sort: this.searchForm.sort,
      }).then(res => {
				console.log(res);
				this.all_products = res.data.products;
				this.productCount = this.all_products.length;
			}, error => {
				console.log('error発生');
				console.log(error);
				this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
				});
			});
		},
		async get_product(id) {
			this.$store.dispatch('product/get_product', {
        id: id,
      }).then(res => {
				console.log(res);
				let g_product = res.data.product;
        this.productForm.status = g_product.status;
        this.productForm.title = g_product.title;
        this.productForm.strong_point = g_product.strong_point;
        this.productForm.image1 = g_product.image1;
        this.productForm.image2 = g_product.image2;
        this.productForm.image3 = g_product.image3;
        this.productForm.image4 = g_product.image4;
        this.productForm.image5 = g_product.image5;
        this.productForm.image6 = g_product.image6;
        this.productForm.image7 = g_product.image7;
        this.productForm.image8 = g_product.image8;
        this.productForm.image9 = g_product.image9;
        this.productForm.image10 = g_product.image10;
        this.productForm.image11 = g_product.image11;
        this.productForm.image12 = g_product.image12;
        this.productForm.image13 = g_product.image13;
        this.productForm.image14 = g_product.image14;
        this.productForm.image15 = g_product.image15;
        this.productForm.movie_tag = g_product.movie_tag;
        this.productForm.comment = g_product.comment;
        this.productForm.price = g_product.price;
        this.productForm.state = g_product.state;
        this.productForm.type = g_product.type;
        this.productForm.brand = g_product.brand;
        this.productForm.model_number = g_product.model_number;
        this.productForm.size_height = g_product.size_height;
        this.productForm.size_width = g_product.size_width;
        this.productForm.size_depth = g_product.size_depth;
        this.productForm.weight = g_product.weight;
        this.productForm.color = g_product.color;
        this.productForm.exterior_finish = g_product.exterior_finish;
        this.productForm.make_year = g_product.make_year;
        this.productForm.make_number = g_product.make_number;
        this.productForm.pedal = g_product.pedal;
        this.productForm.keys_number = g_product.keys_number;
        this.productForm.make_place = g_product.make_place;
        this.productForm.warranty_period = g_product.warranty_period;
        this.productForm.storage_location = g_product.storage_location;
        this.productForm.piano_feature = g_product.piano_feature;
        this.productForm.piano_status = g_product.piano_status;
        this.productForm.manager_name = g_product.manager_name;
        this.productForm.manager_image = g_product.manager_image;
        this.productForm.manager_point = g_product.manager_point;
        this.productForm.accessories = g_product.accessories;
        this.productForm.id = g_product.id;
			}, error => {
				console.log('error発生');
				console.log(error);
				this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
				});
			});
		},
		allClickCallback: function (pageNum) {
      this.all_currentPage = Number(pageNum);
			this.$nextTick(() => {
				window.scrollTo({
					top: 0,
				});
			});
    },
    productFormReset: function () {
      this.productForm.status = 1;
      this.productForm.title = null;
      this.productForm.strong_point = null;
      this.productForm.image1 = null;
      this.productForm.image2 = null;
      this.productForm.image3 = null;
      this.productForm.image4 = null;
      this.productForm.image5 = null;
      this.productForm.image6 = null;
      this.productForm.image7 = null;
      this.productForm.image8 = null;
      this.productForm.image9 = null;
      this.productForm.image10 = null;
      this.productForm.image11 = null;
      this.productForm.image12 = null;
      this.productForm.image13 = null;
      this.productForm.image14 = null;
      this.productForm.image15 = null;
      this.productForm.movie_tag = null;
      this.productForm.comment = null;
      this.productForm.price = null;
      this.productForm.state = 1;
      this.productForm.type = 1;
      this.productForm.brand = 1;
      this.productForm.model_number = null;
      this.productForm.size_height = null;
      this.productForm.size_width = null;
      this.productForm.size_depth = null;
      this.productForm.weight = null;
      this.productForm.color = 1;
      this.productForm.exterior_finish = null;
      this.productForm.make_year = null;
      this.productForm.make_number = null;
      this.productForm.pedal = null;
      this.productForm.keys_number = null;
      this.productForm.make_place = null;
      this.productForm.warranty_period = null;
      this.productForm.storage_location = null;
      this.productForm.piano_feature = null;
      this.productForm.piano_status = null;
      this.productForm.manager_name = null;
      this.productForm.manager_image = null;
      this.productForm.manager_point = null;
      this.productForm.accessories = null;
      this.productForm.id = null;
    },
  },
	computed: {
		allGetProducts: function() {
			let current = this.all_currentPage * this.all_parPage;
			let start = current - this.all_parPage;
			return this.all_products.slice(start, current);
		},
		allGetPageCount: function() {
			return Math.ceil(this.all_products.length / this.all_parPage);
		},
	},
  created() {
    let date = new Date(), year = date.getFullYear();
    this.make_year.push({"no":"0","name":"未選択"});
    for(let i = 1900; i <= year; i++) {
      this.make_year.push({"no":i,"name":String(i)+"年"});
    }
    this.get_products();
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/mypage/seller/product.vue